import { safeDefine } from "../../registration/safe-define.js";
import { NeutralAudioSkinElement } from "../../presets/audio/neutral-skin.js";
import "../../internal/skins/neutral-audio/register.js";
//#region src/define/audio/neutral-skin.ts
safeDefine(NeutralAudioSkinElement);
//#endregion

//# sourceMappingURL=neutral-skin.js.map